import React from 'react';
import { SelectField} from 'components';
import { FormControl } from '@mui/material';

const MenuItems = [
	{ value: 'invalid', disabled:true, text: 'Select one option' }, 
	{ value: '1', disabled:false, text: 'VTK Data Refresh' }, 
	{ value: '2', disabled:false, text: 'VTK Data Refresh From E-mail' },
	{ value: '3', disabled:false, text: 'S12 Thresholds History Update' }, 
	{ value: '4', disabled:false, text: 'Create XML Topology From FTP' },
	{ value: '5', disabled:false, text: 'VTK Data Refresh From OneDrive' }
];

const OptionSelector = ({ onChange, value }) => (
	<FormControl fullWidth>
		<SelectField
			id="inputType"
			name="inputType"
			value={value}
			onChange={(e) => onChange(e.target.value)}
			hintText="Option"
			menuItems={MenuItems}
		/>
	</FormControl>
);

export default OptionSelector;